/**
 * suppress not usefull react errors that we know are not issues
 * to avoid polluting the console with errors that are not usefull to
 * debugging real isses, currenlty ignored errors are:
 * - validateDOMNesting on table that contains text elements, there is nothing we can do about this
 *   due to the strucure of our table header, and this is not causing any issues at the moment
 *
 * PLEASE KEEP THIS LIST UPDATED WITH EXPLAINTIONS OF IGNORED ERRORS
 */
export function patchConsoleError() {
  const original = console.error
  console.error = (...args: unknown[]) => {
    const isNestingWarning = (arg: unknown) => typeof arg === 'string' && arg.includes('validateDOMNesting')
    const concernsOurElements = (arg: unknown) =>
      typeof arg === 'string' && (arg.includes('thead') || arg.includes('th') || arg.includes('td'))
    const [formatString, child, parent] = args
    if ((isNestingWarning(formatString) && concernsOurElements(child)) || concernsOurElements(parent)) {
      return
    }
    original(...args)
  }
}
